import React from 'react';
import { Mail, Info, ChevronRight } from 'lucide-react';
import { useNotifications } from '../context/NotificationContext';
import './EmailSettings.css';

const EmailSettings = () => {
  const { addNotification } = useNotifications();

  const emailTypes = [
    {
      id: 1,
      title: "Email Automático de 'Turno Otorgado Correctamente'",
      status: "Deshabilitado",
      statusType: "disabled"
    },
    {
      id: 2,
      title: "Email de Recordatorio de Turno para turnos dados 30 días antes de su Fecha o más (Automático, 7 días antes del Turno)",
      status: "Deshabilitado",
      statusType: "disabled"
    },
    {
      id: 3,
      title: "Email de Recordatorio de Turno (Automático, 24hs antes del Turno)",
      status: "Habilitado el envío a todos los Pacientes",
      statusType: "enabled"
    }
  ];

  const cancellationRules = [
    { id: 1, category: "CONSULTORIOS EXTERNOS", rule: "Los pacientes podrán cancelar sus turnos hasta 2hs. antes del mismo." },
    { id: 2, category: "ECOGRAFIAS .", rule: "Los pacientes podrán cancelar sus turnos hasta 2hs. antes del mismo." }
  ];

  return (
    <div className="email-settings-page">
      <div className="settings-section card">
        <h1 className="settings-title">Envíos Automáticos de Emails a Pacientes</h1>
        <p className="settings-description">
          Los datos del Consultorio (Nombre Consultorio, Teléfono, Dirección, Email) se incluyen en estos envíos y puedes modificarlos desde la sección <span className="link-text">Datos del Consultorio</span>. Asegúrate de tenerlos ingresados correctamente.
        </p>

        <div className="email-types-list">
          {emailTypes.map(type => (
            <div key={type.id} className="email-type-card">
              <div className="email-type-main">
                <div className="email-icon-wrapper">
                  <Mail size={24} />
                </div>
                <div className="email-type-info">
                  <h3>{type.title}</h3>
                  <p className={`status-text ${type.statusType}`}>{type.status}</p>
                </div>
              </div>
              <button className="btn-view-example" onClick={() => addNotification('Cargando ejemplo de email...', 'info')}>
                VER EJEMPLO
              </button>
            </div>
          ))}
        </div>

        <button className="btn-modify-emails" onClick={() => addNotification('Funcionalidad de edición disponible próximamente.', 'info')}>
          MODIFICAR LOS ENVÍOS A PACIENTES
        </button>
      </div>

      <div className="settings-section card mt-4">
        <h1 className="settings-title">Opción de Cancelar el Turno para los Pacientes</h1>
        <p className="settings-description">
          Puedes elegir para cada Staff Profesional si los pacientes pueden cancelar su turno desde los mensajes de recordatorio, y hasta cuantas horas antes pueden hacer la cancelación.
        </p>

        <button className="btn-modify-all" onClick={() => addNotification('Actualizando reglas para todo el staff...', 'info')}>
          MODIFICAR PARA TODOS
        </button>

        <div className="cancellation-rules-list">
          {cancellationRules.map(item => (
            <div key={item.id} className="rule-item">
              <div className="rule-info">
                <span className="rule-category">{item.category}</span>
                <p className="rule-text">{item.rule}</p>
              </div>
              <button className="btn-modify-link" onClick={() => addNotification(`Modificando reglas para ${item.category}`, 'info')}>
                MODIFICAR
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EmailSettings;
